<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col>
        <b-row align-v="center" align-h="end">
          <b-col>

            <b-form-group align="left">
              <label for="nombreBusq">Fecha</label>
              <b-form-datepicker name="nombre" placeholder="Día"
                                 v-model="fecha"
                                 :max="new Date()"
              ></b-form-datepicker>
            </b-form-group>

          </b-col>
          <b-col>
            <b-form-group align="left">
              <label>Clínica: </label>
              <v-select
                  v-model="idClinica"
                  label="strNombre"
                  :reduce="(variable) => variable.idClinica"
                  :options="listaClinicas"
              >
              </v-select>
            </b-form-group>
          </b-col>


          <b-col class="text-left">
            <b-button variant="outline-primary" @click="obtenerRecibos">Buscar</b-button>
          </b-col>

        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-table
            id="recibos"
            thead-tr-class="columnas"
            :items="datosTablaRecibo"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos"
            fixed>
          <template v-slot:cell(montopagado)="row">
            {{ row.item.montopagado | moneda }}
          </template>
          <template v-slot:cell(saldo)="row">
            {{ row.item.saldo | moneda }}
          </template>
          <template v-slot:cell(aplicacion)="row">
            {{ row.item.aplicacion | moneda }}
          </template>
          <template v-slot:cell(Estatus)="row">
            <b-badge v-if="row.item.activo" variant="success">Activo</b-badge>
            <b-badge v-else variant="danger">Cancelado</b-badge>
          </template>
          <template v-slot:cell(Acciones)="row">
            <b-button-group>
              <!--                                <b-button-->
              <!--                                        title="Detalle del recibo"-->
              <!--                                        size="sm"-->
              <!--                                        @click="detalle(row.item)"-->
              <!--                                        variant="outline-danger"-->
              <!--                                ><em class="fa fa-eye"></em></b-button>-->
              <b-button
                  title="Imprimir"
                  size="sm"
                  @click="imprimir(row.item)"
                  variant="outline-info"
                  :disabled="row.item.loaderRecibo"
              ><em v-if="!row.item.loaderRecibo" class="fa fa-print"></em>
                <b-spinner v-else label="Spinning"></b-spinner>
              </b-button>
              <b-button v-if="!row.item.facturado &&  !row.item.seleccion && row.item.activo"
                        title="Facturar"
                        size="sm"
                        @click="facturar(row.item)"
                        variant="outline-primary"
              ><em class="fa fa-file"></em></b-button>
            </b-button-group>

          </template>
          <template v-slot:cell(fecha)="row">
            {{ row.item.fecha | formatoFechaHora }}
          </template>
          <template v-slot:cell(idRecibo)="row">
            {{ row.item.numeroRecibo !== null ? row.item.numeroRecibo : row.item.idRecibo }}
          </template>
          <template v-slot:cell(Selec.)="row">
            <b-form-checkbox
                v-if="!row.item.facturado && row.item.activo"
                :id="'checkbox-'+row.item.idRecibo"
                v-model="row.item.seleccion"
                :name="'checkbox-'+row.item.idRecibo"
                value="accepted"
                unchecked-value="not_accepted"
            >
            </b-form-checkbox>
          </template>

        </b-table>
        <div align="center" v-if="loaderRecibo">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-if="!loaderRecibo">
          <b-alert v-if="datosTablaRecibo.length === 0" variant="warning" show>No hay datos</b-alert>
        </b-col>
        <b-col v-if="!loaderRecibo">
          <b-pagination
              v-if="datosTablaRecibo !== undefined && datosTablaRecibo.length > 15"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTablaRecibo.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
          ></b-pagination>
        </b-col>
      </b-col>


    </b-row>
    <b-modal v-model="showModalFactura" title="Factura" centered>
      <b-container fluid>

        <b-row>
          <b-col>
            <b-form-group
                id="idfactura"
                label="RFC para factura:"
                label-for="input-1"
            >
              <b-form-select v-model="factura.idDatosFiscales" class="mb-3">
                <b-form-select-option
                    v-for="item in datosFiscales"
                    :key="item.rfc"
                    :value="item"
                >{{ item.rfc }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                id="idfactura"
                label="Nombre de la Razón Social:"
                label-for="input-1"
            >
              <p v-if="factura.idDatosFiscales != null"> {{factura.idDatosFiscales.nombreCompleto}}</p>
              <p v-else></p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
                id="input-group-1"
                label="Uso de CFDI:"
                label-for="input-1"
            >
              <b-form-select v-model="factura.cfdi" class="mb-3">
                <b-form-select-option v-if="aparecerDOI" value="D01"
                >Honorarios médicos, dentales y gastos hospitalarios
                  (D01)
                </b-form-select-option
                >
                <b-form-select-option value="G03"
                >Gastos en general (G03)
                </b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" :disabled="loaderFacturar" @click="realizarFactura()">
          <span v-if="!loaderFacturar">Facturar</span>
          <span v-if="loaderFacturar">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderFacturar" @click="cerrarModal()">Cancelar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Recibos",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTablaRecibo: [],
      loaderRecibo: false,
      fields: [
        {key: "paciente", label: "Paciente", sortable: true},
        {key: "clinica", label: "Clinica", sortable: true},
        {key: "montopagado", label: "Pago", sortable: true},
        {key: "aplicacion", label: "Aplicacion de saldo", sortable: true},
        {key: "saldo", label: "Saldo", sortable: true},
        {key: "idRecibo", label: "Recibo", sortable: true},
        "Estatus",
        "Acciones",
      ],
      registrosPorPagina: 15,
      paginaActual: 1,
      listaClinicas: [],
      idClinica: null,
      fecha: new Date(),
      datosFiscales: [],
      factura: {
        recibos: [],
        idDatosFiscales: null,
        cfdi: null,
        idClinica: null
      },
      loaderFacturar: false,
      showModalFactura: false
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarClinicas();
  },
  methods: {
    obtenerRecibos() {
      this.loaderRecibo = true
      this.datosTablaRecibo = [];

      let fechaActual = this.$moment(this.fecha).set({hour:0,minute:0,second:0,millisecond:0});


      let fechaF = this.$moment(this.fecha).set({hour:23,minute:59,second:59,millisecond:999})

      let fechaInicial = fechaActual.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      let fechaFinal = fechaF.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");


      const envio = {
        fechaInicio : fechaInicial,
        fechaFin : fechaFinal,
        idClinica: this.idClinica
      }
      this.$http.post(this.$api + 'fiscales/obtener/recibos/porClinica',envio).then(respuesta => {
            if (respuesta.data.data) {
              this.datosTablaRecibo = respuesta.data.data
              this.datosTablaRecibo.forEach(it => {
                it.loaderRecibo = false;
              })
            }
          }
      ).finally(() => {
            this.loaderRecibo = false;
          }
      )
    },
    llenarClinicas() {
      this.$http
          .get(this.$api + "catalogos/listaClinicas")
          .then((response) => {
            if (response.status === 200) {
              this.listaClinicas = response.data.data
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    imprimir(item) {
      item.loaderRecibo = true;
      const envio = {
        idRecibo: item.idRecibo,
        horas: this.$horas(),
        esReciboPti: false
      }

        if ([2,7].includes(item.tipoRecibo)) {
        this.$http.post(this.$api + 'reportes/recibo', envio).then(respuesta => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data
                this.descargar('Recibo-' + item.idRecibo + new Date(), datos)
              }
            }
        ).finally(() => {
          item.loaderRecibo = false;
          this.loaderRecibo = false;
        })
      } else {
          envio.esReciboPti = true;
        this.$http.post(this.$api + 'reportes/recibo', envio).then(respuesta => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data
                this.descargar('Recibo-' + item.idRecibo + new Date(), datos)
              }
            }
        ).finally(() => {
          item.loaderRecibo = false;
          this.loaderRecibo = false;
        })
      }
    },
    descargar(nombre, datos) {

      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: 'application/pdf'});

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombre;
      link.click();
    },
    facturar(item) {
      this.obtenerRfcs(item)
      this.showModalFactura = true;
      this.factura.recibos = [];
      this.factura.recibos.push(item.idRecibo);
      this.factura.idClinica = this.$localStorageService.getIdClinica();
    },
    obtenerRfcs(item) {
      const parametros = {idPaciente: item.idPaciente}
      this.$http.post(this.$api + 'fiscales/obtener/datosFiscalesActivo', parametros).then(respuesta => {
        if (respuesta.data.data) {
          this.datosFiscales = respuesta.data.data
        }
      });
    },
    realizarFactura() {
      if (this.factura.recibos.length > 0) {
        this.loaderFacturar = true;
        this.factura.horas =  this.$horas();
        this.factura.puesde = true;
        const envio = JSON.parse(JSON.stringify(this.factura));
        envio.idDatosFiscales = this.factura.idDatosFiscales.idDatosFiscales
        this.$http.post(this.$api + 'facturacion/timbrar', envio).then(respuesta => {
              if (respuesta.data.data) {

                if (respuesta.data.data.includes('exito')) {
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "Se generó la factura correctamente",
                  });
                  this.showModalFactura = false;
                  this.obtenerRecibos();
                  this.obtenerFacturas();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Aviso",
                    html: respuesta.data.data,
                  });
                  this.obtenerFacturas();
                }
              }
            }
        ).finally(() => {
          this.loaderFacturar = false;
        })
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: 'Seleccione el/los recibos a facturar',
        });
      }
    },
    cerrarModal() {
      this.showModalFactura = false
    },
    validarTipo(item) {
      const valor = this.datosFiscales.filter(
          (value) => value.idDatosFiscales === item
      )[0];
      this.aparecerDOI = valor.tipoPersona === 1;
    },
  }
}
</script>

<style scoped>

</style>
